var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"step",class:_vm.displayStep},[_c('div',{staticClass:"step-container"},_vm._l((3),function(num){return _c('i',{key:num},[_vm._v(_vm._s(num))])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }